// extracted by mini-css-extract-plugin
module.exports = {"title":"EmailVerification_title__xq894"};